import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireAdmin } from "./auth/RequireAdmin";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { AnalyticsUserPage } from "./pages/AnalyticsUserPage";
import { AnalyticsFilePage } from "./pages/AnalyticsFilePage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/folder/:folderId"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/analytics"
        element={
          <RequireAdmin>
            <AnalyticsPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/analytics/users/:userId"
        element={
          <RequireAdmin>
            <AnalyticsUserPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/analytics/files/:fileId"
        element={
          <RequireAdmin>
            <AnalyticsFilePage />
          </RequireAdmin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
